import ProtocoleLayout from "@/components/ProtocoleLayout";
import { PROTOCOLE_CAFARDS } from "@/data/protocoles";

const ProtocoleCafards = () => (
    <ProtocoleLayout
        testid="protocole-cafards-page"
        tag="Procédure avant & après le traitement"
        title="Protocole"
        accent="cafards & blattes"
        intro={PROTOCOLE_CAFARDS.intro}
        avant={PROTOCOLE_CAFARDS.avant}
        apres={PROTOCOLE_CAFARDS.apres}
        attention={PROTOCOLE_CAFARDS.attention}
        ctaTitle="Prêt pour l'intervention ?"
        ctaSubtitle="Logement préparé, colonie éliminée : prenez rendez-vous dès maintenant. Intervention sous 2h, 7j/7."
        pdfUrl="/assets/protocole-cafards.pdf"
        seoTitle="Protocole cafards & blattes : avant & après traitement | Eradikbreizh"
        seoDescription="Préparez votre logement avant un traitement anti-cafards : hygiène, gel insecticide, pulvérisation. Consignes après intervention pour une éradication durable de la colonie."
    />
);

export default ProtocoleCafards;
